import { Box, styled, StyleSystemProps } from '@withjoy/joykit';

export const StyledRPCSectionContainer = styled(Box)``;

const rpcSectionContainerStyles: StyleSystemProps = {
  width: '100%',
};

const rpcSectionSkeletonStyles: StyleSystemProps = {
  width: '100%',
  paddingTop: 10,
};

const rpcSectionCarouselStyles: StyleSystemProps = {
  width: '100%',
  paddingTop: 10,
};

export const styles = {
  rpcSectionContainer: rpcSectionContainerStyles,
  rpcSectionSkeleton: rpcSectionSkeletonStyles,
  rpcSectionCarousel: rpcSectionCarouselStyles,
};
